import React from 'react';

interface Props {
  children: any;
}

export default (props: Props) => <div className="Box_content">{props.children}</div>;
